import { useContext } from 'react'
import { AuthContext } from '../AuthProvider'

export const useProfile = () => {
  const ctx = useContext(AuthContext)
  return ctx?.profile
}
